import {Enumify} from "enumify-ts";

class ConsignmentImageType extends Enumify<ConsignmentImageType>() {

    static PICK_UP_DOCKET = new ConsignmentImageType("Pickup Docket");
    static COMPLETION_PHOTO = new ConsignmentImageType("Completion Photo");
    static OTHER_PHOTO = new ConsignmentImageType("Other Photo");
    static _ = ConsignmentImageType._closeEnum();

    constructor(
        public description: string
    ) {
        super();
    }

}

export default ConsignmentImageType;
